// @ts-ignore
import jwtDecode from 'jwt-decode';

export function getAccessToken(accessTokenName) {
  return window.localStorage.getItem(accessTokenName);
}

export function deleteAccessToken(accessTokenName) {
  localStorage.removeItem(accessTokenName);
}

export function setAccessToken(accessTokenName, accessToken) {
  if (accessToken) {
    window.localStorage.setItem(accessTokenName, accessToken);
  } else {
    console.error('setAccessToken: accessToken not defined');
  }
}

function decodeJWT(accessToken) {
  try {
    const decoded = jwtDecode(accessToken);
    return decoded;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Error token decode: ${error}`);
    return null;
  }
}

export function getDataFromAccessToken(accessTokenName) {
  const accessToken = getAccessToken(accessTokenName);

  if (!accessToken) {
    return {};
  }

  const decoded = decodeJWT(accessToken);

  return decoded || {};
}

export function getExpAccessToken(accessTokenName) {
  const { exp } = getDataFromAccessToken(accessTokenName);

  return exp || 0;
}

export function isValidAccessToken(accessTokenName) {
  // * время создания токена в секундах
  const exp = getExpAccessToken(accessTokenName);
  //  * текущая дата в секундах
  const dateNow = new Date().getTime() / 1000;

  // * если до протухания токена осталась < 30  - токен невалид
  return exp - dateNow > 30;
}



// WEBPACK FOOTER //
// ./src/utils/tokens.js